import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useSitesList() {
  const isSitesFormSidebarActive = ref(false);
  const sitesData = ref({});
  const contentsData = ref(null);
  const { t } = useI18nUtils();
  const sites = ref([]);
  const toast = useToast();
  const refSitesListTable = ref(null);
  const tableColumns = [
      { key: '', label: '', sortable: false },
      { key: 'site_name', label: 'Site Name', sortable: false },
      { key: 'domain', label: 'Domain', sortable: false },
      { key: 'site_types_id', label:'Site Type', sortable:false},
      { key: 'is_active', label: 'Status', sortable: false },
      { key: 'action', label: '#', sortable: false },
  ]
  const perPage = ref(10);
  const totalSites = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const statusFilter = ref(null);
  const siteTypesFilter = ref(null)
  const siteTypesData = ref([])
  const refSitesTypeListTable = ref(null);
  const siteTypes = ref([])
  const dataMeta = computed(() => {
    const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
    const to = Math.min(
      totalSites.value,
      perPage.value * currentPage.value
    );
    return {
      from,
      to,
      of: totalSites.value,
    }
  })

  store.dispatch('app-sites/getSiteTypes').then(response => {
    siteTypesData.value = response.data.data
  })

  const resolveCatStatusVariant = status => {
    if (status) return 'success'
    if (!status ) return 'secondary'
    return 'primary'
  }

  const resolveCatStatusnameVariant = status => {
    if (status) return 'Active'
    if (!status) return 'Inactive'
    return 'primary'
  }

  watch([currentPage, perPage, searchQuery, statusFilter, siteTypesFilter], () => {
    refetchData()
  })

  const refetchData = () => {
    // refSitesTypeListTable.value.refresh()
    fetchData()
  }

  const fetchData = (ctx, callback) => {
    const offset = perPage.value*(currentPage.value-1);

    store.dispatch('app-sites/fetchSites', {
      limit: perPage.value,
      offset: offset,
      keywords: searchQuery.value,
      order_by: 'ordering_count ASC',
      site_types_id: siteTypesFilter.value
    })
    .then(response => {
      sites.value  = response.data.data
      totalSites.value = response.data.total
    })
    .catch(() => {
      toast({
        component: ToastificationContent,
        props: {
          title: "Error fetching Category' list",
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    })
  }

  const updateSitesOrdering = ()=>{
    store.dispatch('app-sites/updateSitesOrdering', sites.value).then(response => {})
  }
  
  const updateSite = async (data)=>{
    sitesData.value = null
    
    if(data) {
      sitesData.value = data
    }
    
    isSitesFormSidebarActive.value = true;
  }

  const deleteData = (id) => {
    store.dispatch('app-sites/deleteSite', id).then(response => {
      
      toast({
        component: ToastificationContent,
        props: {
          title: "Delete Success",
          icon: 'AlertTriangleIcon',
          variant: 'success',
        },
      })

      refetchData();
    }).catch(()=>{
      toast({
        component: ToastificationContent,
        props: {
          title: "Error Delete Blog",
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    })
  }
    
  return {
    resolveCatStatusVariant,
    resolveCatStatusnameVariant,
    refetchData,
    fetchData,
    tableColumns,
    isSitesFormSidebarActive,
    sitesData,
    contentsData,
    t,
    sites,
    refSitesListTable,
    totalSites,
    perPageOptions,
    sortBy,
    isSortDirDesc,
    dataMeta,
    perPage,
    currentPage,
    searchQuery,
    statusFilter,
    updateSitesOrdering,
    updateSite,
    deleteData,
    siteTypesData,
    siteTypes,
    siteTypesFilter,
    refSitesTypeListTable
  }
}